export default "__VITE_ASSET__cMidpiI8__"